import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AlertsContext from "common/providers/alerts";
import TrainingExerciseForm from "./TrainingExerciseForm";

function TrainingExercise() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "training-exercises",
    id
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/training-exercises");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataTrainingExercise: any) => {
      const trainingExercise = { ...dataTrainingExercise };

      try {
        if (trainingExercise.id) {
          await updateItem(trainingExercise.id, trainingExercise);
        } else {
          await saveItem(trainingExercise);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <TrainingExerciseForm onSubmit={onSubmit} trainingExercise={item} />
  );
}

export default TrainingExercise;
